<template>
	<div class="central content flex flex-align-start">
		<div class="flex-1 mr40">
			<div><el-page-header @back="goBack" content="选调资讯"></el-page-header></div>
			<div style="min-height: 300px;padding: 5px 0 50px;" v-loading="isLoading">
				<div class="rich-text" v-html="ArticleContent"></div>
			</div>
		</div>
		
		<!-- 宣传图 -->
		<el-carousel class="border-radius-10" style="width: 360px;" trigger="click" :interval="5000" arrow="never" height="480px">
			<el-carousel-item v-for="(item,index) in swiper" :key="index">
				<el-image style="width: 360px;height: 480px;" :src="item.image" fit="cover"></el-image>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'
export default {
	name: 'Targeted',
	data(){
		return{
			ArticleContent: localStorage.getItem('ArticleContent'),
		}
	},
	mounted(){
		EventBus.$emit('router-path', this.$route.path)
		
		if(this.token) this.getUser()
	},
	methods: {
		goBack(){
			this.$router.go(-1)
		}
	}
}
</script>

<style>
.el-descriptions-item__label.is-bordered-label{
	width: 140px !important;
}
</style>